export const API_BASE_URL = process.env.REACT_APP_API_ROUTE || 'http://localhost:3001';
export const CHAT_API_URL = `${API_BASE_URL}/whatsappchat`;

// Debug: mostrar las URLs construidas
console.log('API_BASE_URL:', API_BASE_URL);
console.log('CHAT_API_URL:', CHAT_API_URL);
export const POLLING_INTERVAL = 5000;
export const MESSAGE_TYPES = {
    TEXT: 'text',
    IMAGE: 'image',
    AUDIO: 'audio',
    VIDEO: 'video',
    DOCUMENT: 'document',
    LOCATION: 'location'
};
